/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Profile_Delete_Account_DescriptionInputs */

const es_user_profile_delete_account_description = /** @type {(inputs: User_Profile_Delete_Account_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta acción es irreversible. Tu cuenta y todos los datos asociados serán eliminados permanentemente.`)
};

const en_user_profile_delete_account_description = /** @type {(inputs: User_Profile_Delete_Account_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This action is irreversible. Your account and all associated data will be permanently deleted.`)
};

/**
* | output |
* | --- |
* | "This action is irreversible. Your account and all associated data will be permanently deleted." |
*
* @param {User_Profile_Delete_Account_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const user_profile_delete_account_description = /** @type {((inputs?: User_Profile_Delete_Account_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Profile_Delete_Account_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_user_profile_delete_account_description(inputs)
	return en_user_profile_delete_account_description(inputs)
});
export { user_profile_delete_account_description as "user.profile.delete_account.description" }